import { Box } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { z } from 'zod';

import { SettlementReportsContainer } from 'packages/loans/ui/settlementReports/SettlementReportsContainer';
import { useCreditFacilityOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { PermissionGuard } from '~/core/PermissionGuard';
import { PortfolioTemplate } from '~/packages/portfolio/ui/shared/PortfolioTemplate';

// Types
const RouteParamsStruct = z.object({
  creditFacility: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const [queryParams] = useSearchParams();
  const { creditFacility: creditFacilityId } = RouteParamsStruct.parse(
    Object.fromEntries(queryParams),
  );
  const creditFacility = useCreditFacilityOrThrow(creditFacilityId);

  return (
    <PermissionGuard
      permissions={(context) =>
        context.flags.isSlsAgentLender ? 'allow' : 'deny'
      }
    >
      <PortfolioTemplate
        creditFacilityId={creditFacility.id}
        creditFacilityName={creditFacility.name}
        selectedTab="settlementReports"
      >
        <SettlementReportsContainer creditFacilityId={creditFacility.id} />
      </PortfolioTemplate>
    </PermissionGuard>
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/portfolio/overview/facilities" />;
      }}
    >
      <Box width="100%" padding="2.5rem">
        <RouteBase />
      </Box>
    </RouteErrorBoundary>
  );
};
